/**
 * The picker's metric sections. A plain catalog (the Flow Optimizer's) is one
 * "Metrics" list; a catalog whose metrics carry a section (the Automation's
 * drops: "Tracker (Voluum / Binom)" · "SMSWiser" · "Tracker + SMSWiser")
 * gets one heading per section, in the catalog's order.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { MetricOption } from '../metric-options';
import type { KindOptionGroup } from './condition-kind';

export function metricOptionGroups(metrics: MetricOption[], prefix: string): KindOptionGroup[] {
  const sections = new Map<string, KindOptionGroup['options']>();
  for (const m of metrics) {
    const label = m.section ?? 'Metrics';
    sections.set(label, [...(sections.get(label) ?? []), { value: prefix + m.value, label: m.label }]);
  }
  return [...sections].map(([label, options]) => ({ label, options }));
}
